import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";


export class ViesValidation {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

 run(cif: string): Promise<{ [key: string]: string; }> {
    return this.dispatcher.dispatch('invoices.vies.validation', cif)
  }
}